import { useTranslations } from 'hooks/useTranslations';
import * as yup from 'yup';

export const useGalleryEntrySchema = () => {
  const { t } = useTranslations();

  const schema = yup.object({
    entryIdsForRemoval: yup.array().of(yup.string()),
    entryParameters: yup
      .array()
      .of(
        yup.object({
          uniqueId: yup.string().required(),
          filename: yup
            .string()
            .required(t('general.field.validation.required'))
            .max(50, t('general.field.validation.maxCharacters').replace('{0}', '50')),
          position: yup.number(),
        }),
      )
      .required(),
  });

  return { schema };
};
